import React, { useState } from 'react';
import { ArrowUpRightIcon, InstagramIcon, LinkedinIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
const posts = [['Materialidad: cómo elegir acabados que envejecen bien', 'Diseño', 'https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&w=800&q=80'], ['La luz natural como materia de proyecto', 'Arquitectura', 'https://images.unsplash.com/photo-1600585152915-d208bec867a1?auto=format&fit=crop&w=800&q=80'], ['Reformar sin perder el carácter de una casa', 'Reformas', 'https://images.unsplash.com/photo-1600607688969-a5bfcd646154?auto=format&fit=crop&w=800&q=80']];
export function EditorialContact() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    if (!data.get('name') || !data.get('email') || !data.get('message')) {
      setError('Completá nombre, email y mensaje para enviarnos tu consulta.');
      return;
    }
    setError('');
    setSent(true);
    e.currentTarget.reset();
  };
  return <>
      <section className="mx-auto grid max-w-[1440px] gap-8 px-5 py-24 md:grid-cols-[1.6fr_.7fr] md:px-10 lg:py-32" data-id="element-41">
        <div data-id="element-42">
          <img src="https://images.unsplash.com/photo-1600607688960-e095ff83135c?auto=format&fit=crop&w=1600&q=88" alt="Sala de estar con luz natural" className="h-[500px] w-full object-cover" data-id="element-43" />
          <div className="mt-4 grid grid-cols-3 gap-3" data-id="element-44">
            {['photo-1600566753190-17f0baa2a6c3', 'photo-1600210491892-03d54c0aaf87', 'photo-1600607687939-ce8a6c25118c'].map(x => <img key={x} alt="Detalle arquitectónico" src={`https://images.unsplash.com/${x}?auto=format&fit=crop&w=400&q=80`} className="h-28 w-full object-cover" data-id="element-45" />)}
          </div>
        </div>
        <div className="flex flex-col justify-center" data-id="element-46">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#C4724A]" data-id="element-47">
            Proyecto destacado
          </p>
          <h2 className="font-editorial mt-5 text-4xl leading-tight" data-id="element-48">
            Casa Umbral
          </h2>
          <p className="mt-6 text-sm leading-7 text-[#655f57]" data-id="element-49">
            Una ampliación que buscó abrir una vivienda familiar al jardín sin
            perder la escala íntima de sus espacios originales.
          </p>
          <a href="#contacto" className="mt-8 flex items-center gap-2 text-xs font-bold uppercase tracking-wider" data-id="element-50">
            Ver proyecto completo <ArrowUpRightIcon size={16} data-id="element-51" />
          </a>
        </div>
      </section>
      <section className="bg-white px-5 py-24 md:px-10" data-id="element-52">
        <div className="mx-auto max-w-[1440px]" data-id="element-53">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#C4724A]" data-id="element-54">
            Ideas y reflexiones
          </p>
          <h2 className="font-editorial mt-5 text-4xl md:text-5xl" data-id="element-55">
            Pensar el espacio
          </h2>
          <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-56">
            {posts.map(([title, tag, img]) => <article key={title} data-id="element-57">
                <img src={img} alt="" className="h-56 w-full object-cover" data-id="element-58" />
                <p className="mt-5 text-[10px] font-bold uppercase tracking-[.18em] text-[#C4724A]" data-id="element-59">
                  {tag}
                </p>
                <h3 className="font-editorial mt-3 text-2xl leading-snug" data-id="element-60">
                  {title}
                </h3>
                <a href="#contacto" className="mt-4 inline-block text-xs font-bold uppercase tracking-wider" data-id="element-61">
                  Leer más →
                </a>
              </article>)}
          </div>
        </div>
      </section>
      <section id="contacto" className="grid lg:grid-cols-2" data-id="element-62">
        <div className="bg-[#1A1A1A] px-7 py-20 text-white md:px-16 lg:px-24" data-id="element-63">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#d88b67]" data-id="element-64">
            Contacto
          </p>
          <h2 className="font-editorial mt-5 max-w-md text-5xl leading-tight" data-id="element-65">
            ¿Tenés un proyecto en mente?
          </h2>
          <p className="mt-6 max-w-sm text-sm leading-7 text-white/65" data-id="element-66">
            Contame tu idea. La primera consulta es sin cargo.
          </p>
          <div className="mt-12 space-y-5 text-sm text-white/80" data-id="element-67">
            <p className="flex gap-3" data-id="element-68">
              <MailIcon size={18} className="text-[#C4724A]" data-id="element-69" />
              hola@mariavictoriacorbalan.arq
            </p>
            <p className="flex gap-3" data-id="element-70">
              <PhoneIcon size={18} className="text-[#C4724A]" data-id="element-71" />
              +598 99 555 019
            </p>
            <p className="flex gap-3" data-id="element-72">
              <InstagramIcon size={18} className="text-[#C4724A]" data-id="element-73" />
              @mariavictoriacorbalan.arq
            </p>
            <p className="flex gap-3" data-id="element-74">
              <MapPinIcon size={18} className="text-[#C4724A]" data-id="element-75" />
              Montevideo, Uruguay
            </p>
          </div>
        </div>
        <div className="bg-[#F7F4EF] px-7 py-20 md:px-16 lg:px-24" data-id="element-76">
          <h2 className="font-editorial text-3xl" data-id="element-77">Hablemos de tu idea</h2>
          {sent && <p role="status" className="mt-5 bg-[#e5eee2] p-4 text-sm text-[#405238]" data-id="element-78">
              Gracias por escribir. Te responderé a la brevedad.
            </p>}
          {error && <p role="alert" className="mt-5 text-sm text-[#a34d31]" data-id="element-79">
              {error}
            </p>}
          <form noValidate onSubmit={submit} className="mt-6 grid gap-5" data-id="element-80">
            <label className="text-xs font-bold" data-id="element-81">
              Nombre completo
              <input name="name" className="input-field" data-id="element-82" />
            </label>
            <label className="text-xs font-bold" data-id="element-83">
              Email
              <input name="email" type="email" className="input-field" data-id="element-84" />
            </label>
            <label className="text-xs font-bold" data-id="element-85">
              Teléfono <span className="font-normal" data-id="element-86">(opcional)</span>
              <input name="phone" className="input-field" data-id="element-87" />
            </label>
            <label className="text-xs font-bold" data-id="element-88">
              Tipo de proyecto
              <select name="type" className="input-field" data-id="element-89">
                <option data-id="element-90">Vivienda</option>
                <option data-id="element-91">Reforma</option>
                <option data-id="element-92">Local</option>
                <option data-id="element-93">Interiores</option>
                <option data-id="element-94">Otro</option>
              </select>
            </label>
            <label className="text-xs font-bold" data-id="element-95">
              Mensaje
              <textarea name="message" rows={3} className="input-field resize-none" placeholder="Contame un poco sobre tu idea..." data-id="element-96" />
            </label>
            <button className="mt-3 bg-[#C4724A] py-4 text-xs font-bold uppercase tracking-wider text-white hover:bg-[#a95d3b]" data-id="element-97">
              Enviar consulta
            </button>
          </form>
        </div>
      </section>
      <footer className="bg-[#1A1A1A] px-5 py-12 text-white md:px-10" data-id="element-98">
        <div className="mx-auto flex max-w-[1440px] flex-col gap-8 md:flex-row md:items-center md:justify-between" data-id="element-99">
          <div data-id="element-100">
            <p className="font-editorial text-2xl" data-id="element-101">VC Estudio</p>
            <p className="mt-2 text-xs text-white/50" data-id="element-102">
              Arquitectura que transforma formas de vivir.
            </p>
          </div>
          <nav className="flex gap-5 text-xs text-white/70" data-id="element-103">
            <a href="#inicio" data-id="element-104">Inicio</a>
            <a href="#proyectos" data-id="element-105">Proyectos</a>
            <a href="#contacto" data-id="element-106">Contacto</a>
          </nav>
          <div className="flex gap-4" data-id="element-107">
            <InstagramIcon size={18} data-id="element-108" />
            <LinkedinIcon size={18} data-id="element-109" />
          </div>
        </div>
        <div className="mx-auto mt-10 flex max-w-[1440px] justify-between border-t border-white/15 pt-5 text-[10px] text-white/40" data-id="element-110">
          <span data-id="element-111">© 2025 María Victoria Corbalan</span>
          <span data-id="element-112">Diseñado con intención</span>
        </div>
      </footer>
    </>;
}